import { Group } from "@mantine/core";
import { HeaderTabs } from "./HeaderTabs";
import { LeftNav } from "./LeftNav";
import { RightNav } from "./RightNav";

export const Header = () => {
  return (
    <Group w={"100%"} h={"100%"} align="center" gap={0} bg={"gray.1"}>
      <LeftNav />
      <HeaderTabs />
      <RightNav />
    </Group>
  );
};
